module.exports = __webpack_public_path__ + "img/hexa_logo_login.49c05267.png";